module.exports = __webpack_public_path__ + "static/img/science.5e3e8efd.png";